module.exports = __webpack_public_path__ + "static/media/invite.1e2c8bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/invite.png
// module id = 352
// module chunks = 0